import settings from './beam-engine/settings';

const stats = {}

const pixelRatio  = 2;

const width       = 200; 
const height      = 150; 
const padding     = 10 * pixelRatio;
const lineHeight  = 14 * pixelRatio;
const fontSize    = 12 * pixelRatio;
const fontColor   = '#fff';
const textAlign   = 'left';

const $canvasWrapper  = document.createElement('div')
$canvasWrapper.style.width  = '200px';
$canvasWrapper.style.opacity = 0.7;

const $fpsCanvas  = document.createElement('canvas')
const fpsCtx      = $fpsCanvas.getContext('2d')
$fpsCanvas.id     = 'fps-canvas';
$fpsCanvas.width  = width  * pixelRatio;
$fpsCanvas.height = 100 * pixelRatio
$fpsCanvas.style.width  = '200px';
$canvasWrapper.appendChild( $fpsCanvas );

let lastDate       = performance.now();
let lastFPSUpdate = performance.now();
let currFPS       = 0;
let FPSentries    = [];

function updateFPSGUI() {

    let newDate = performance.now();
    let delta   = newDate - lastDate;
    lastDate    = newDate;

    // make FPS value more readable
    if (newDate - lastFPSUpdate > 120) {
        currFPS = Math.floor(1000 / delta + 0.5)
        lastFPSUpdate = newDate;
        FPSentries.push( currFPS );
        if (FPSentries.length > 60) {
            FPSentries.splice(0,1);
        }
    }

    //clear
    fpsCtx.clearRect( 0, 0, $fpsCanvas.width, $fpsCanvas.height  )

    // fps large text
    fpsCtx.font        = `${fontSize}px sans-serif`;
    fpsCtx.textAlign   = 'left'
    fpsCtx.fillStyle   = fontColor
    fpsCtx.fillText(`FPS: ` + currFPS,  5 * pixelRatio,  100 * pixelRatio - lineHeight );

    //fps grid
    fpsCtx.linewidth = 4;
    fpsCtx.strokeStyle = '#fff';
    [0, 30, 60, 90, 120].forEach(r => {
        fpsCtx.beginPath();
        fpsCtx.moveTo(0,                      120 - r + 5 * pixelRatio);
        fpsCtx.lineTo( $fpsCanvas.width - 40, 120 - r + 5 * pixelRatio);
        fpsCtx.stroke();
        fpsCtx.fillStyle = '#fff';
        fpsCtx.textAlign = "left";
        fpsCtx.font      = `${20}px sans-serif`;
        fpsCtx.fillText(r, $fpsCanvas.width - 35, 120 - r + 8 + 5 * pixelRatio );
    });

    //fps meter
    fpsCtx.linewidth = 4;
    fpsCtx.strokeStyle = '#2edb21';
    fpsCtx.beginPath();
    fpsCtx.moveTo(0, 120 - 60 + 5 * pixelRatio);
    for (let i=0; i<FPSentries.length; i++) {
        fpsCtx.lineTo(i * 5, 120 - FPSentries[i] + 5 * pixelRatio);
    }
    fpsCtx.stroke();
}

function update() {
	requestAnimationFrame( update )
    updateFPSGUI();
}

requestAnimationFrame(update);

class GLStats extends HTMLElement {
    connectedCallback() {
        this.appendChild( $canvasWrapper );
    }
}

customElements.define('gl-stats-old', GLStats);




let FPS = 0;
if (settings.debug) {
    let lastStatDate = Date.now()
    let lastDrawnDate = Date.now()
    let $stats2Canvas = document.createElement('canvas')
    let stats2Ctx = $stats2Canvas.getContext('2d')
    $stats2Canvas.width  = 150
    $stats2Canvas.height = 60
    $stats2Canvas.style.position = 'fixed'
    $stats2Canvas.style.right = '50%'
    $stats2Canvas.style.top = 0
    $stats2Canvas.style.pointerEvents = 'none'
    $stats2Canvas.style.zIndex = 100000000
    document.body.appendChild( $stats2Canvas )
    function updateStats2() {
        requestAnimationFrame( updateStats2 )
        FPS = (1000/(Date.now()-lastStatDate))>>0
        if (Date.now() - lastDrawnDate > 10) {
            stats2Ctx.fillStyle = '#ff0000'
            stats2Ctx.fillRect( 0, 0, $stats2Canvas.width, $stats2Canvas.height  )
            stats2Ctx.font = '12px sans-serif'
            stats2Ctx.textAlign = 'left'
            stats2Ctx.fillStyle = '#fff'
            stats2Ctx.fillText('FPS: '+FPS, 10, 12)
            lastDrawnDate = Date.now()
        }
        lastStatDate = Date.now()
    }
	updateStats2()
}



export default stats;